import React from 'react'
import html from '../Asset/html.png'
import css from '../Asset/css.png'
import tailwind from '../Asset/tailwind.png'
import js from '../Asset/js.png'
import react from '../Asset/react.png'
import nextjs from '../Asset/nextjs.png'
import graphql from '../Asset/graphql.png'
import github from '../Asset/github.png'

const Experience = () => {

            const experiences = [
                {
                   id : 1,
                   src : html,
                   title : 'HTML',
                   style : 'shadow-purple-700'
                },
                {
                   id : 2,
                   src : css,
                   title : 'CSS',
                   style : 'shadow-pink-500'
                },
                {
                   id : 3,
                   src : tailwind,
                   title : 'TailwindCss',
                   style : 'shadow-cyan-500'
                },
                {
                   id : 4,
                   src : js,
                   title : 'JS',
                   style : 'shadow-yellow-500'
                },
                {
                   id : 5,
                   src : react,
                   title : 'React',
                   style : 'shadow-sky-500'
                },
                {
                   id : 6,
                   src : nextjs,
                   title : 'NextJS',
                   style : 'shadow-white'
                },
                {
                   id : 7,
                   src : github,
                   title : 'Github',
                   style : 'shadow-gray-500'
                },
                {
                   id : 8,
                   src : graphql,
                   title : 'GraphQl',
                   style : 'shadow-pink-500'
                },
            ]

  return (
    <div name="Experience" 
         className=' bg-gradient-to-t from-gray-800 to-black text-white width-full h-screen '
    >
       <div className=' max-w-screen-lg  mx-auto flex flex-col justify-center p-4  w-full h-full'>
        <div>
            <p className='text-4xl font-bold border-b-4 inline border-gray-500 p-2'>Experience</p>
            <p className='py-6'>This are the technologies that i have learned and creating new idea</p>
        </div>
         <div className='w-full grid grid-cols-2 sm:grid-cols-3 gap-8 text-center px-12 sm:px-0'>

{
    experiences.map(({id,src,title,style})=>(

        <div 
        key={id}
        className={`shadow-md hover:scale-105 duration-200 cursor-pointer py-2 rounded-lg ${style}`}
        >
        <img src={src}
         alt=""
         className=' w-20 mx-auto'
         />
        <p className='pt-4'>
            {title}
        </p>
        </div>

    ))
}

         </div>
       </div>
    </div>
  )
}

export default Experience
